import { render, staticRenderFns } from "./reset-datafile-modal.vue?vue&type=template&id=5350a8e6"
import script from "./reset-datafile-modal.vue?vue&type=script&lang=js"
export * from "./reset-datafile-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports